import { Button, Box, Typography, Grid, IconButton } from '@mui/material';
import React, { useState, useEffect } from 'react';
import CustomInput from '../Custom/CustomInput';
import { MdRemoveCircleOutline } from 'react-icons/md';

const GuestForm = ({ onGuestListUpdate }) => {
  const [guests, setGuests] = useState([]);

  const handleInputChange = (index, event) => {
    const values = [...guests];
    
    // Check if event is from MuiTelInput (comes directly as a value string) or a regular input event
    if (typeof event === 'string') {
      // This is from MuiTelInput
      values[index]['phoneNumber'] = event;
    } else {
      // This is from a regular input
      values[index][event.target.name] = event.target.value;
    }
    
    setGuests(values);
  };

  // Auto-update parent component when guest list changes
  useEffect(() => {
    // Filter guests that have both fields filled
    const validGuests = guests.filter(guest => 
      guest.fullName?.trim() && guest.phoneNumber?.trim()
    );
    
    if (onGuestListUpdate) {
      onGuestListUpdate(validGuests);
    }
  }, [guests, onGuestListUpdate]);

  const handleAddGuest = () => {
    setGuests([...guests, { fullName: '', phoneNumber: '' }]);
  };


  const handleDeleteGuest = (index) => {
    const values = [...guests];
    values.splice(index, 1);
    setGuests(values);
  };

  const isAddButtonDisabled = () => {
    if (guests.length > 0) {
      const lastGuest = guests[guests.length - 1];
      return !lastGuest.fullName || !lastGuest.phoneNumber;
    }
  };

  return (
    <>
      <Button
        disabled={isAddButtonDisabled()}
        onClick={handleAddGuest}
        sx={{
          borderRadius: '10px',
          py: 1.5,
          fontSize: { lg: '14px', md: '14px', sm: '12px', xs: '12px' },
        }}
        fullWidth
        variant="contained"
      >
        Add Guest(s)
      </Button>

      <Box>
        {guests.map((guest, index) => (
          <Box
            sx={{
              border: '1px solid #d7d7d7',
              p: 2,
              borderRadius: '10px',
              mt: 2,
            }}
            key={index}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography
                color="primary"
                sx={{
                  fontWeight: 500,
                  fontSize: { lg: '14px', md: '14px', sm: '12px', xs: '12px' },
                }}
              >
                Guest {index + 1}
              </Typography>

              <IconButton onClick={() => handleDeleteGuest(index)}>
                <MdRemoveCircleOutline style={{ color: '#BC172F' }} />
              </IconButton>
            </Box>
            <Grid container spacing={2} style={{ marginBottom: '10px' }}>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <CustomInput
                  fullWidth
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                  value={guest.fullName}
                  onChange={(event) => handleInputChange(index, event)}
                  style={{ marginRight: '10px' }}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <CustomInput
                  fullWidth
                  type="phone_number"
                  name="phoneNumber"
                  placeholder="Phone Number"
                  value={guest.phoneNumber}
                  onChange={(value) => handleInputChange(index, value)}
                  style={{ marginRight: '10px' }}
                />
              </Grid>
            </Grid>
          </Box>
        ))}
        {guests?.length > 0 && (
          <Button
            disabled={isAddButtonDisabled()}
            onClick={handleAddGuest}
            sx={{
              mt: 2,
              fontSize: { lg: '14px', md: '14px', sm: '12px', xs: '12px' },
            }}
          >
            Add Another Guest
          </Button>
        )}
      </Box>
    </>
  );
};

export default GuestForm;
